module.exports = __webpack_public_path__ + "img/logo.f6248445.png";